<template>
  <div class="get-access">
    <div class="container">
      <h2 class="h2">
        {{ getAccessTitle }}
      </h2>
      <p class="body-1">
        {{ getAccessDescription }}
      </p>
      <div class="features-holder">
        <ul class="features">
          <li
            v-for="(feature,i) in features"
            :key="i"
            class="feature body-2"
          >
            {{ feature.name }}
          </li>
        </ul>
      </div>
      <div v-if="buttonText && buttonLink" class="button-holder">
        <nuxt-link :to="buttonLink" class="btn-primary btn-lg">
          {{ buttonText }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    features: { type: Array, default: () => [], required: true },
    buttonText: { type: String, default: '', required: false },
    buttonLink: { type: String, default: '', required: false },
    getAccessTitle: { type: String, default: 'Get Access to Live Training' },
    getAccessDescription: { type: String, default: 'Sign up for a live training session and powershift your data-fueled workflow optimization with real-time, skills-based learning by top industry-leading instructors.' },
  },
};
</script>

<style lang="scss" scoped>
  .get-access {
    text-align: center;
    color: var(--main-light);
    background-image: url('../../assets/images/live-trainings.jpg');
    image-rendering: -webkit-optimize-contrast;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      background-color: var(--main-dark);
      opacity: 0.9;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 200px;
      background: linear-gradient(0deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 47.92%, rgba(0, 12, 31, 0) 100%);
    }

    .container {
      padding-top: 145px;
      padding-bottom: 145px;
      position: relative;
      z-index: 1;
      opacity: 0.9;
    }

    .h2 {
      max-width: 610px;
      margin: 0 auto;
    }

    .body-1 {
      max-width: 730px;
      margin: 11px auto 64px;
    }

    .features-holder {
      text-align: left;
      display: flex;
      flex-direction: column;
      align-items: center;

      .features {
        list-style: none;
        margin: 0;

        .feature {
          margin-bottom: var(--spacing-24);
          line-height: 100%;
          background-image: url('../../assets/svg/icon-list-check.svg');
          image-rendering: -webkit-optimize-contrast;
          background-repeat: no-repeat;
          padding-left: var(--spacing-30);
          font-size: 18px;
        }
      }
    }

    .btn-primary {
      margin-top: 31px;
      z-index: 1;
      width: 100%;
      max-width: 280px;
    }
  }

  @include bp($bp-mobile) {
    .get-access {
      .h2 {
        font-size: 32px;
      }

      .body-1 {
        font-size: 18px;
      }

      .features-holder {
        .features {
          padding: 0;
        }
      }

      .btn-primary {
        max-width: 328px;
      }
    }
  }

  @include bp($bp-phone) {
    .get-access {
      background-position: center top;

      &:before {
        opacity: 0.8;
      }

      .container {
        padding-top: var(--spacing-120);
        padding-bottom: var(--spacing-120);

        &:before,
        &:after {
          content: '';
          position: absolute;
          top: 0;
          height: 100%;
          z-index: -1;
        }

        &:before {
          left: 0;
          width: 65px;
          background: linear-gradient(90deg, rgba(0, 12, 31, 0.96) 0%, rgba(0, 12, 31, 0.7) 43.23%, rgba(0, 12, 31, 0.1) 100%);
        }

        &:after {
          right: 0;
          width: 55px;
          background: linear-gradient(270deg, rgba(0, 12, 31, 0.96) 0%, rgba(0, 12, 31, 0.7) 43.23%, rgba(0, 12, 31, 0.1) 100%);
        }
      }

      .body-1 {
        margin-bottom: 31px;
      }

      .btn-primary {
        max-width: 328px;
      }
    }
  }
</style>
